import * as type from '../types/user';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestUser = actionCreator(type.REQUEST_USER);
export var successUser = actionCreator(type.SUCCESS_USER);
export var failureUser = actionCreator(type.FAILURE_USER);
export var requestResetUser = actionCreator(type.REQUEST_RESET_USER);
export var successResetUser = actionCreator(type.SUCCESS_RESET_USER);
export var requestUpdateUser = actionCreator(type.REQUEST_UPDATE_USER);